import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'react-bootstrap';
import ChatCard from './components/ChatCard';

const RoomChat = () => {
  const { t } = useTranslation('common');

  return (
    <Container>
      <Row hidden>
        <Col md={12}>
          <h3 className="page-title ml-2">Chat</h3>
        </Col>
      </Row>
      <Row>
        <ChatCard />
      </Row>
    </Container>
  );
};

export default RoomChat;
